import ConfirmationScreenDetails from "./ConfirmationScreenDetails"
import ProcessingScreen from "./ProcessingScreen"
import processSale from "./processSale"

// Card reader selection is done on the confirmation screen, so we do not validate here.
export const CreditCard = {
  ConfirmationScreenDetails,
  ProcessingScreen,
  processSale,
  validatePaymentMethod: () => null,
  customerSelection: "optional",
  surchargeEligible: true,
  // The reader doesn't know the card's funding until capture, so the surcharge
  // is shown optimistically here (label hedged, line shown regardless of funding)
  // and reconciled/unwound later if the card turns out to be debit. The other
  // surcharge-eligible flows know funding at confirmation and gate on credit.
  optimisticSurchargeDisplay: true,
  paymentFlowName: "Credit Card Reader",
}
